// extracted by mini-css-extract-plugin
module.exports = {"grid":"SectionTeam-module--grid--2JYfV","grid2":"SectionTeam-module--grid2--2RmBZ SectionTeam-module--grid--2JYfV","header":"SectionTeam-module--header--3_fcs"};